import { Col } from 'antd';
import styled from 'styled-components';

export const CustomCol = styled(Col)`
	margin: 0 0 1rem 1rem;
`;
